const isProduction = process.env.NODE_ENV === 'production';

// 优先读取对应构建环境的配置；未配置时按环境提供安全回退。
const defaultBaseUrl = isProduction
  ? '/wapi'
  : 'http://air3.shuzhiren.com:32183';

export const baseUrl = process.env.VUE_APP_API_BASE_URL || defaultBaseUrl;

// 文件上传地址
export const uploadUrl = `${isProduction ? baseUrl : ''}/api/common/uploadFileToLocal`;
